const initialState =null ;
const ActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case "getActivityData":
      return (state = action.payload);
    default:
      return state;
  }
};

export default ActivityReducer;
